import _extends from "@babel/runtime/helpers/extends";
import React, { useReducer } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var initialState = {
  windowStyle: 'MacOS',
  lineHighlight: false,
  lineNumbers: false,
  windowTitle: true,
  disableTitle: true,
  enableShadow: true,
  fontSize: 14,
  width: '',
  borderRadius: 5,
  padding: 20,
  offsetX: 0,
  offsetY: 5,
  blurRadius: 20,
  spreadRadius: 0,
  color: '#0000008f'
};
function reducer(state, action) {
  return _extends({}, state, action);
}
export var ContextSetting = /*#__PURE__*/React.createContext({
  state: initialState,
  dispatch: () => {}
});
export var ProviderSetting = _ref => {
  var {
    children
  } = _ref;
  var [state, dispatch] = useReducer(reducer, initialState);
  return /*#__PURE__*/_jsx(ContextSetting.Provider, {
    value: {
      state,
      dispatch
    },
    children: children
  });
};